// src/app/services/performance-series/use-source-mode.ts
//
// React hook exposing the GLOBAL Performance data-source mode reactively. The
// value comes from the backend (app_config) via resolveSourceMode(); components
// re-render when it first resolves and again whenever an admin flips it (which
// fires "analytics:refresh").

import { useEffect, useState } from "react";
import { resolveSourceMode, getSeriesSourceModeCached } from "./source";
import type { SeriesSourceMode } from "./source-setting-api";

export function useSeriesSourceMode(): SeriesSourceMode {
  const [mode, setMode] = useState<SeriesSourceMode>(getSeriesSourceModeCached());

  useEffect(() => {
    let alive = true;
    const sync = () => {
      resolveSourceMode().then((m) => {
        if (alive) setMode(m);
      });
    };
    sync();
    if (typeof window !== "undefined") {
      window.addEventListener("analytics:refresh", sync);
      return () => {
        alive = false;
        window.removeEventListener("analytics:refresh", sync);
      };
    }
    return () => {
      alive = false;
    };
  }, []);

  return mode;
}
